import Popup from "../../utils/popup";

class PopupDaneDoFakturyVat {
  constructor() {
    this.formID = "#dane_do_faktur";
    this.$buttonAdd = $(".js-vat-btn-add");
    this.$buttonChange = $(".js-vat-btn-change");
    this.buttonCancel = "#dane_do_faktur-btn_cancel";
    this.redirectUrlID = "#dane_do_faktur-redirect_url";
    this.redirectUrlValue = "uzytkownik--twoje-konto";
    this.popups = [];
  }

  getUrl() {
    const _this = this;
    const $collection = this.$buttonAdd.add(this.$buttonChange);

    $collection.each(function() {
      let url = $(this).attr("href");
      let clickedButtonID = $(this).attr("id");

      _this.sendRequest(url, clickedButtonID);
    });
  }

  getForm(response, formID) {
    const $response = $(response);
    const $form = $response.find(formID);
    const $formScript = $form.prev();

    $form.find(this.buttonCancel).attr("data-dismiss", "modal");
    $form.find(this.redirectUrlID).val(this.redirectUrlValue);

    return $form.add($formScript);
  }

  sendRequest(url, button) {
    const _this = this;

    $.get(url, function(response) {
      let $response = $(response);

      _this.popups.push(
        new Popup(
          _this.getForm($response, _this.formID),
          "#" + button,
          false,
          false
        )
      );
    }).fail(function() {
      console.error("Błąd Ajax");
    });
  }

  init() {
    this.getUrl();
  }
}

export default PopupDaneDoFakturyVat;
